import CalculateCommissionAffiliate from 'components/CalculateCommissionAffiliate';
import PermissionHide from 'components/PermissionHide';
import React, { Fragment } from 'react';
import { FormattedNumber } from 'react-intl';

interface IProps {
  product: any;
  commission?: 'percentage' | 'subscription' | 'normal' | 'coproduction';
}

enum ChargeType {
  SIGNATURE = 'A',
  NORMAL = 'N',
  OPENED = 'L',
  FREE = 'G',
}

const ShowPrice = ({ product, commission }: IProps) => {
  if (product.has_children) {
    return (
      <div className='price'>
        <p className='view__children'>
          <b>Consultar variações</b>
        </p>
      </div>
    );
  }

  if (commission === 'percentage') {
    return (
      <div className='price'>
        <div className='value'>
          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
            {product.coproduction_commission_type == 'P' ? (
              (product.coproduction_commission_percent || 0) + '%'
            ) : (
              <FormattedNumber value={product.coproduction_commission_value || 0} format='BRL' />
            )}
          </PermissionHide>
          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
            <em>oculto</em>
          </PermissionHide>
        </div>
      </div>
    );
  }

  if (commission === 'subscription') {
    return (
      <div className='price'>
        <div className='value'>
          <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
            <FormattedNumber value={product.comission_subscription || 0} format='BRL' />
          </PermissionHide>
          <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
            <em>oculto</em>
          </PermissionHide>
        </div>
      </div>
    );
  }

  return (
    <div className='price'>
      <div className='value'>
        {product.charge_type === ChargeType.SIGNATURE && (
          <span>
            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
              <FormattedNumber value={product.recurring_value ? product.recurring_value : 0} format='BRL' /> recorrente
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </span>
        )}

        {product.charge_type === ChargeType.NORMAL && (
          <Fragment>
            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
              <FormattedNumber value={product.price} format='BRL' />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </Fragment>
        )}

        {(!product.charge_type || product.charge_type === ' ') && (
          <Fragment>
            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
              <FormattedNumber value={0} format='BRL' />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </Fragment>
        )}

        {product.charge_type === ChargeType.OPENED && (
          <Fragment>
            <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
              Valor Aberto
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </Fragment>
        )}

        {product.charge_type === ChargeType.FREE && <span>Grátis</span>}
      </div>

      {commission === 'normal' && (
        <div className='commission'>
          {product.charge_type === ChargeType.SIGNATURE && (
            <span className='commission'>
              <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                <CalculateCommissionAffiliate
                  price={product.recurring_value ? product.recurring_value : 0}
                  commissionType={product.recurring_comission_type}
                  commissionValue={product.recurring_comission_value}
                />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                <em>oculto</em>
              </PermissionHide>
              &nbsp;de Comissão recorrente
            </span>
          )}

          {product.charge_type === ChargeType.NORMAL && (
            <span className='commission'>
              <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                <CalculateCommissionAffiliate
                  price={product.price ? product.price : 0}
                  commissionType={product.comission_type}
                  commissionValue={product.comission_value}
                />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                <em>oculto</em>
              </PermissionHide>
              &nbsp;de Comissão
            </span>
          )}

          {product.charge_type === ChargeType.FREE && (
            <span className='commission'>
              <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                <CalculateCommissionAffiliate
                  price={product.price ? product.price : 0}
                  commissionType={product.comission_type}
                  commissionValue={product.comission_value}
                />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                <em>oculto</em>
              </PermissionHide>
              &nbsp;de Comissão
            </span>
          )}

          {(!product.charge_type || product.charge_type === ' ') && (
            <span className='commission'>
              <PermissionHide inverse={1} action='myeduzz:meus-produtos:ocultar-valores'>
                <CalculateCommissionAffiliate price={0} commissionType={'V'} commissionValue={0} />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:meus-produtos:ocultar-valores'>
                <em>oculto</em>
              </PermissionHide>
              &nbsp;de Comissão
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ShowPrice;
